import React from 'react';
import { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import './layout.scss'


const Banner = ({ message, link }) => {

	const [isVisible, setIsVisible] = useState(true);

	const handleClose = () => {
		setIsVisible(false);
	};

	if (!isVisible) {
		return null;
	}
	return (

			<div className="banner-cobranza d-flex mb-3">
				<p className='fw-regular ms-auto'>{message}
					<a href={link} target='_blank'> enlace</a>
				</p>
				<Icon name='delete' onClick={handleClose} size='large' color='grey' className='icon-banner-cobranza' link />
			</div>
	);
};

export default Banner;